import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
 import MasterLayout from "@/layouts";
import EnergyDashboard from "@/pages/Ownerpage/Charts/Mockchart";

import ChartApplication from "@/pages/Dashboard";
import ExecutiveSummary from "@/pages/Ownerpage/ExecutiveSummary";
import HullData from "@/pages/Misc/HullData";
import EnginePredictives from "@/pages/Misc/EnginePredictives";
import WindDirectionChart from "@/pages/MarineDirection";
import PermissionPage from "../../pages/PermissionPage";
import ValidationRulesManager from "@/pages/Ownerpage/ValidationRules/create-validation-rules";
const OwnerFillProgress = React.lazy(() =>
  import("@/pages/Ownerpage/Dashboard/OwnerFillProgress")
);

const MaritimeDashboard = React.lazy(() =>
  import("@/pages/Ownerpage/Dashboard/index")
);
const DataAnalytics = React.lazy(() =>
  import("@/pages/Ownerpage/DataAnalytics")
);
const OwnerBenchmarks = React.lazy(() =>
  import("@/pages/Benchmarks/Owner/OwnerBenchmarks")
);
const BenchmarkDetail = React.lazy(() =>
  import("@/pages/Benchmarks/Owner/BenchmarkDetail")
);

const OwnerDataEditing = React.lazy(() =>
  import("@/pages/Ownerpage/OwnerEditing")
);
const ShipWarnings = React.lazy(() => import("@/pages/Ownerpage/ShipWarning"));
const ShipEditing = React.lazy(() => import("@/pages/Ownerpage/ShipEdit"));
const OwnerAdministration = React.lazy(() =>
  import("@/pages/Ownerpage/OwnerAdministration")
);
const ProcessedDataDetails = React.lazy(() =>
  import("@/pages/Ownerpage/ProcessedData/ProcessedDataDetails")
);

const ProcessedData = React.lazy(() =>
  import("@/pages/Ownerpage/ProcessedData")
);

const OwnerDashboard = React.lazy(() => import("@/pages/Ownerpage/Dashboard"));

const Charts = React.lazy(() => import("@/pages/Ownerpage/Charts"));

const OwnerFleets = React.lazy(() => import("@/pages/Ownerpage/Maps"));

const EventOverview = React.lazy(() =>
  import("@/pages/Ownerpage/EventOverview")
);
const MarineDashboard = React.lazy(() => import("@/pages/MarineDirection"));


const OwnerRoutes = () => {
  ;
  return (
    <MasterLayout>
      <Routes>
        <Route path="/" element={<OwnerDashboard />} />
        <Route path="/dashboard" element={<MaritimeDashboard />} />
        <Route path="/administration" element={<OwnerAdministration />} />
        <Route path="/edit-shipdetails/:shipid" element={<ShipEditing />} />
        <Route path="/chart" element={<EnergyDashboard />} />
         <Route path="/ship-warnings" element={<ShipWarnings />} />
        <Route path="/executve-summary" element={<ExecutiveSummary />} />
        <Route path="/benchmarks" element={<OwnerBenchmarks />} />
        <Route
          path="/benchmarks-detail/:benchmark_id"
          element={<BenchmarkDetail />}
        />
        <Route path="/charts/:reportType/:topic" element={<ChartApplication />} />
        <Route path="/charts/:reportType/:topic/:imo_number/:period" element={<ChartApplication />} />

        <Route path="/charts/:reportType" element={<ChartApplication />} />

        <Route path="/process-data" element={<ProcessedData />} />
        <Route
          path="/process-data/:tablename"
          element={<ProcessedDataDetails type="MYSQL" />}
        />
        <Route
          path="/process-data/:tablename/pg"
          element={<ProcessedDataDetails type="PG" />}
        />

        <Route path="/map-location" element={<OwnerFleets />} />
        {/* <Route path="/ship-users" element={<Ownerusers />} /> */}
        <Route path="/user-data" element={<OwnerDataEditing />} />
        <Route path="/data-analytics" element={<DataAnalytics />} />

        <Route path="/event-calendar" element={<EventOverview />} />
        <Route path="/hull-data" element={<HullData />} />
        <Route path="/engine-predictives" element={<EnginePredictives />} />
        <Route path="permission/:action?" element={<PermissionPage />} />        <Route path="/addvalidationrules" element={<ValidationRulesManager />} />
        <Route path="/test" element={<WindDirectionChart />} />
      </Routes>
    </MasterLayout>
  );
};

export default OwnerRoutes;
